class AccountConfigRepository {
  /**
   * @name AccountConfigRepository#api
   * @type {Api}
   */

  constructor (api) {
    this.api = api
  }

  getDateFormat () {
    return 'm/d/Y'
  }

  getMomentDateFormat () {
    return 'MM/DD/YYYY'
  }

  getCustomerGroupIds () {
    return this.api.customers.getGroups().then(groups => {


      let ret = {
        nonMemberGroupId: 0,
        emailMemberGroupId: 0,
        nonEmailMemberGroupId: 0,
        maxGroupId: 0,
      }


      console.log("getMaxCustomerGroupId request", groups)

      groups.forEach(group => {
        switch(group.name) {
          case 'Non-Member':
            ret.nonMemberGroupId = parseInt(group.customerGroupID)
            break;

          case 'Email Member':
            ret.emailMemberGroupId = parseInt(group.customerGroupID)
            break;

          case 'Non-Email Member':
            ret.nonEmailMemberGroupId = parseInt(group.customerGroupID)
            break;

          default:
            break;
        }
      });

      ret.maxGroupId = ret.emailMemberGroupId;
      return ret
    })
  }
}
export default AccountConfigRepository



// WEBPACK FOOTER //
// ./src/model/AccountConfigRepository.js